// component

import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import classnames from "classnames";
import CustomerContentTitle from "./CustomerContentTitle";
import { UserTypes as UserTypes2s } from "../../../api/auth";

interface CustomerContentProps {
    contents: Array<any>
}

const selectorData = createSelector(
    (state: any) => state.Login,
    (state: any) => state.Profile2,
    (login, profile2) => ({
        isUserLogin: login.isUserLogin,
        error: login.error,
        loginLoading: login.loading,
        isUserLogout: login.isUserLogout,

        logonUserName: profile2.userName,
        profile2: profile2,
        activeGroupId: profile2.activeGroupId
    })
);


const onTitleClick = () => {

}

const CustomerContent = ({ contents }: CustomerContentProps) => {
    const { dispatch, useAppSelector } = useRedux();
    const { profile2, activeGroupId } = useAppSelector(selectorData);
    const isCustomer = (profile2 && profile2.userType == UserTypes2s.Customer);    

    // console.log('customer content :', contents);

    return (
        <>
            {isCustomer &&
                (contents || []).map((content: any, key: number) => {
                    return (
                        <div key={key}>
                            <h5 className="mb-1 px-4 mt-3 font-size-11 text-muted text-uppercase room-group-title">
                                {content.contentName}
                            </h5>
                            <div className="chat-message-list">
                                <ul className="list-unstyled chat-list chat-user-list">
                                    <CustomerContentTitle
                                        contentTitles={content.contentTitles}
                                    />
                                </ul>
                            </div>
                        </div>
                    )
                })
            }
        </>
    );
};

export default CustomerContent;
